import { useContext, useState, useEffect } from "react";
import { DataContext } from "../DataContext";
import { useAuth0 } from "@auth0/auth0-react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { HeaderLogo, IconLogoDark, ShoppingBagIcon } from "../svgs";

import { MenuButton, NavigationBar, NavigationItems, Announcements, NavLinks, CartIcon, LogoAndNav, Wrapper } from "../styles";

function NavbarComponent() {
  const { isLoading, isAuthenticated, loginWithRedirect } = useAuth0();

  const handleNavbarSignIn = async () => {
    try {
      await loginWithRedirect({
        appState: {
          returnTo: window.location.pathname + window.location.search + window.location.hash,
        },
      });
    } catch (error) {
      const code = String(error?.error || error?.code || "").toLowerCase();
      if (!["popup_closed", "popup_cancelled", "popup_timeout", "user_cancelled"].includes(code)) {
        console.error("Auth0 sign-in failed:", error);
      }
    }
  };
  const [showModal, setShowModal] = useState(false);
  const [showStickyHeader, setShowStickyHeader] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);
  const { productsInCart, addVisitedPage } = useContext(DataContext);

  const location = useLocation();

  useEffect(() => {
    // Close the modal when the route changes
    setShowModal(false);
    addVisitedPage(location.pathname);
  }, [location]);

  useEffect(() => {
    const media = window.matchMedia("(min-width: 768px)");

    const handleScroll = () => {
      setShowStickyHeader(window.scrollY > 57);
    };

    const applyMode = () => {
      if (media.matches) {
        // Desktop
        window.addEventListener("scroll", handleScroll);
        handleScroll(); // set initial state
      } else {
        // Non-desktop
        window.removeEventListener("scroll", handleScroll);
        setShowStickyHeader(false);
        window.scrollTo({ top: 0, behavior: "auto" }); // or "smooth"
      }
    };

    applyMode(); // run on mount
    media.addEventListener("change", applyMode);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      media.removeEventListener("change", applyMode);
    };
  }, []);

  const AccountButton = () => {
    if (isAuthenticated) {
      return (
        <Link className="account-link" to={"/account"} aria-label="My Account">
          Account
        </Link>
      );
    }
    return (
      <Link className="account-link" onClick={handleNavbarSignIn} role="button">
        Sign In
      </Link>
    );
  };

  const handleMobileNav = () => {
    handleShowModal();
  };

  const productsCount = productsInCart.reduce((sum, product) => sum + Number(product.quantity), 0);

  const ProductLinks = () => (
    <NavLinks>
      <Link to="/products/premium-comfort-tee">Premium Tees</Link>
      <Link to="/products/active-stretch-polo">Polos</Link>
      <Link to="/products/active-stretch-polo">Quarter-Zips</Link>
      <Link to="/member-signup">Member Perks</Link>
    </NavLinks>
  );

  const AccountLinks = () => (
    <>
      <NavLinks>
        <Link to="/order-lookup">Order Lookup</Link>
        <AccountButton />
      </NavLinks>
      <CartIcon className="bag-link" to="/bag" aria-label="Shopping Bag">
        <ShoppingBagIcon aria-hidden="true" />
        {productsCount > 0 && <span>{productsCount}</span>}
      </CartIcon>
    </>
  );

  return (
    <>
      <NavigationBar className={`${showStickyHeader && "hide"}`}>
        <NavigationItems>
          <LogoAndNav>
            <Link className="logo" to="/" aria-label="Back to Grey Gull Homepage">
              <HeaderLogo />
            </Link>
            <div className="slogan">
              Men's Apparel <span></span> 5'8" and Under
            </div>
          </LogoAndNav>

          <div className="nav-menu right">
            <ProductLinks />
          </div>

          <div className="nav-menu right">
            <AccountLinks />
          </div>
          <MenuButton onClick={handleMobileNav}>
            <i className="fa-solid fa-bars"></i>
          </MenuButton>
        </NavigationItems>
      </NavigationBar>
      <Announcements>FREE SHIPPING on orders $100+</Announcements>

      {showStickyHeader && (
        <NavigationBar className="sticky-header-template">
          <NavigationItems className="sticky-header-items">
            <LogoAndNav className="sticky-logo-wrap">
              <Link className="logo" to="/" aria-label="Back to Grey Gull Homepage">
                <IconLogoDark />
              </Link>
              <div className="announcements">FREE SHIPPING on orders $100+</div>
            </LogoAndNav>

            <div className="nav-menu right">
              <ProductLinks />

              <AccountLinks />
            </div>
            <MenuButton onClick={handleMobileNav}>
              <i className="fa-solid fa-bars"></i>
            </MenuButton>
          </NavigationItems>
        </NavigationBar>
      )}

      <Modal fullscreen={true} animation={false} show={showModal} onHide={handleCloseModal}>
        <Wrapper className="modal-styles navigation">
          <Modal.Header closeButton>
            <Modal.Title>
              <LogoAndNav>
                <Link className="logo" to="/" aria-label="Back to Grey Gull Homepage">
                  <HeaderLogo />
                </Link>
                <div className="slogan">
                  Men's Apparel <span></span> 5'8" and Under
                </div>
              </LogoAndNav>
            </Modal.Title>
          </Modal.Header>
          <Announcements>FREE SHIPPING on orders $100+</Announcements>

          <Modal.Body>
            <div className="mobile-navigation">
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/account">Account</Link>
                </li>
                <li>
                  <Link to="/bag">Shopping Bag</Link>
                </li>
              </ul>
            </div>
          </Modal.Body>
        </Wrapper>
      </Modal>
    </>
  );
}

export default NavbarComponent;
